import { Modal, Spinner } from "react-bootstrap";

export default function FinishModal({isOpen, onClose}) {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Body className="text-center">
        <Spinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        Please wait while we process your assessment
      </Modal.Body>
    </Modal>
  );
}